import style from 'containers/MyHealth/components/MyHealthResultsContext/styles'
import { FONT_FAMILY, MINIMUM_FONT_SIZE } from 'styles/typography'
const themeStyles = colors => {
  const styles = {
    ...style(colors),
    fieldName: {
      fontSize: MINIMUM_FONT_SIZE,
      fontWeight: 700,
      textTransform: 'uppercase',
      textWrap: 'wrap'
    },
    medicationUppercase: {
      fontSize: MINIMUM_FONT_SIZE,
      fontWeight: 700,
      textTransform: 'uppercase',
      textWrap: 'wrap',
      opacity: 0
    },
    noPadding: {
      padding: 0
    },
    noPaddingTop: {
      paddingTop: 0,
      marginTop: '-0.5rem'
    },
    learnMoreContainer: {
      paddingTop: 0,
      marginTop: '-1rem',
      marginBottom: '-1rem'
    },
    loadMoreButton: {
      margin: 'auto',
      marginTop: '1rem',
      display: 'block',
      textTransform: 'uppercase',
      background: colors.primary,
      color: colors.textWhite,
      borderRadius: 25,
      border: 'none'
    },
    itemName: {
      marginBottom: '1rem',
      overflowWrap: 'anywhere',
      fontFamily: FONT_FAMILY,
      fontSize: 14,
      fontWeight: 700
    },
    learnMoreButton: {
      marginLeft: 0
    }
  }
  return styles
}

export default themeStyles
